module.exports = __webpack_public_path__ + "ad33ee06faf23c06d0a6b208a5148c56.svg";